import { audio } from '../systems/audio/AudioSystem.js';
import { REDEEM_CODES } from '../data/redeemCodes.js';

/** Lets the player enter a one-time code for a currency reward (see data/redeemCodes.js). */
export class RedeemCodeMenu {
  constructor(root, save, { onBack }) {
    this.root = root;
    this.save = save;
    this.onBack = onBack;
    this.status = '';
    this.statusIsError = false;
    this.el = document.createElement('div');
    this.el.className = 'menu-overlay';
    this._render();
    this.root.appendChild(this.el);
  }

  _render() {
    this.el.innerHTML = '';

    const title = document.createElement('div');
    title.className = 'menu-title';
    title.textContent = 'REDEEM CODE';
    this.el.appendChild(title);

    const subtitle = document.createElement('div');
    subtitle.className = 'menu-subtitle';
    subtitle.textContent = 'Enter a code to redeem a one-time reward.';
    this.el.appendChild(subtitle);

    const form = document.createElement('form');
    form.className = 'settings-rows';

    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'login-name-input';
    input.placeholder = 'Enter code';
    input.maxLength = 30;
    form.appendChild(input);

    const submit = document.createElement('button');
    submit.type = 'submit';
    submit.className = 'menu-button menu-button-primary';
    submit.textContent = 'Redeem';
    form.appendChild(submit);

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      this._handleRedeem(input.value);
    });
    this.el.appendChild(form);

    if (this.status) {
      const status = document.createElement('div');
      status.className = this.statusIsError ? 'login-error' : 'login-status';
      status.textContent = this.status;
      this.el.appendChild(status);
    }

    const back = document.createElement('button');
    back.type = 'button';
    back.className = 'menu-button';
    back.textContent = 'Back';
    back.addEventListener('click', () => { audio.playSfx('click'); this.onBack(); });
    this.el.appendChild(back);
  }

  _handleRedeem(rawCode) {
    audio.playSfx('click');
    const code = rawCode.trim().toUpperCase();
    if (!code) {
      this.status = 'Enter a code first.';
      this.statusIsError = true;
      this._render();
      return;
    }

    const reward = REDEEM_CODES[code];
    if (!reward) {
      this.status = 'That code is not valid.';
      this.statusIsError = true;
      this._render();
      return;
    }

    if (this.save.hasRedeemedCode(code)) {
      this.status = "You've already redeemed this code.";
      this.statusIsError = true;
      this._render();
      return;
    }

    if (reward.echoes) this.save.addEchoes(reward.echoes);
    if (reward.shards) this.save.addShards(reward.shards);
    this.save.markCodeRedeemed(code);
    this.status = `Redeemed! ${reward.description ?? 'Reward granted.'}.`;
    this.statusIsError = false;
    this._render();
  }

  destroy() {
    this.el.remove();
  }
}
